import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'formatDecimal'})
export class FormatDecimalPipe implements PipeTransform {
  transform(value: number, decimals?: number): string {
    return value.toFixed(decimals ?? 2).replace('.', ',');
  }
}